import { render, staticRenderFns } from "./DetailGadai.vue?vue&type=template&id=9e16b768&"
import script from "./DetailGadai.vue?vue&type=script&lang=js&"
export * from "./DetailGadai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports